// extracted by mini-css-extract-plugin
export default {"imageWrapper":"fF-z","hovered":"gF-z","hoverImage":"hF-z","mainImage":"iF-z","imageNoBackground":"jF-z","fullSizeImage":"kF-z"};